import GridComponent from './component';

export default GridComponent;
